module.exports = __webpack_public_path__ + "img/KLB.b58a961e.png";